import { useCallback, useEffect } from 'react';
import { usePortal, useUser } from '../useNavConfig';
import { getSurveyContactId, postRatingAndFeedback } from './utils';
import { captureException } from '../../utils/sentryAPI';
import useFeedbackReducer from '../useFeedbackReducer';
import { FeedbackRating } from '../useFeedbackReducer/constants';
import { useAppDispatch } from '..';
import { setDisplayFeedbackModal } from '../../reducers/AppConfig';
const numericalFeedbackRatings = {
  [FeedbackRating.UNHAPPY]: 0,
  [FeedbackRating.NEUTRAL]: 1,
  [FeedbackRating.HAPPY]: 2
};
const useVerticalNavSurvey = ({
  displayFeedbackModal
}) => {
  const {
    email
  } = useUser();
  const {
    portalId
  } = usePortal();
  const dispatch = useAppDispatch();
  const {
    setSurveyContactId,
    setFeedback,
    setRating,
    setContactConsent,
    closeSurvey,
    feedbackState,
    incrementSurveyStep,
    resetSurvey
  } = useFeedbackReducer();
  const {
    surveyContactId,
    rating,
    feedback,
    activeStep,
    contactConsent
  } = feedbackState;
  const completeSurvey = useCallback(() => {
    if (!rating || !surveyContactId || !displayFeedbackModal) {
      resetSurvey();
      dispatch(setDisplayFeedbackModal({
        displayFeedbackModal: undefined
      }));
      return;
    }
    closeSurvey();
    return postRatingAndFeedback({
      followUp: `${feedback.trim() || 'undefined'} (can contact: ${contactConsent})`,
      rating: numericalFeedbackRatings[rating],
      contactId: surveyContactId,
      feedbackSurveyType: displayFeedbackModal
    }).then(() => {
      dispatch(setDisplayFeedbackModal({
        displayFeedbackModal: undefined
      }));
      resetSurvey();
    }).catch(err => {
      captureException(err);
      dispatch(setDisplayFeedbackModal({
        displayFeedbackModal: undefined
      }));
      resetSurvey();
    });
  }, [closeSurvey, contactConsent, dispatch, displayFeedbackModal, feedback, rating, resetSurvey, surveyContactId]);
  useEffect(() => {
    if (!displayFeedbackModal || surveyContactId || !portalId || !email) return;
    getSurveyContactId({
      email,
      portalId,
      feedbackSurveyType: displayFeedbackModal
    }).then(id => setSurveyContactId(id)).catch(err => {
      captureException(err);
    });
  }, [displayFeedbackModal, email, portalId, setSurveyContactId, surveyContactId]);
  return {
    setRating,
    setFeedback,
    setContactConsent,
    surveyContactId,
    feedback,
    rating,
    activeStep,
    contactConsent,
    completeSurvey,
    incrementSurveyStep,
    resetSurvey
  };
};
export default useVerticalNavSurvey;